module.exports = __webpack_public_path__ + "img/mdh2.5fc14090.jpg";